"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { PRODUCTS_BINDING, PRODUCTS_BINDING_INPUT } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const imageNavLinksListInputs = [
  {
    name: "variant",
    type: "string",
    defaultValue: "default",
    enum: ["default", "promo-horizontal", "promo-vertical"],
  },
  PRODUCTS_BINDING_INPUT,
] as const satisfies Inputs;

export const ImageNavLinksListComponent: RegisteredComponent = {
  name: "ImageNavLinksList",
  canHaveChildren: true,
  noWrap: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
  },
  inputs: imageNavLinksListInputs,
  component: dynamic(async () =>
    withValidation(
      imageNavLinksListInputs,
      (await import("./ImageNavLinksList")).ImageNavLinksList,
      "ImageNavLinksList"
    )
  ),
  defaults: {
    bindings: PRODUCTS_BINDING,
  },
};
